import React, { useEffect, useMemo, useState, useRef } from "react";
import styles from "./ExpenseCafeGasanNew.module.css";
import api from "../../../api";
import { useTabActivated } from "../../../tabs/TabActivation";
import ExpenseItemPanel from "./ExpenseItemPanel";
import VendorPanel from "./VendorPanel";
import SalaryPanel from "./SalaryPanel";

export default function ExpenseCafeGeumnaraeNew() {
  const [draftDate, setDraftDate] = useState(() => toISO(new Date()));
  const [executionDate, setExecutionDate] = useState("");

  // ⬇ 작성일 변경 → 집행예정일 자동 설정
  useEffect(() => {
    console.log("📌 draftDate 변경 감지 → executionDate 자동 설정");
    setExecutionDate(draftDate);
  }, [draftDate]);


  const [seq, setSeq] = useState("001");
  const [title, setTitle] = useState("");
  const [saving, setSaving] = useState(false);
  const [savedId, setSavedId] = useState(null);
  const [remark, setRemark] = useState("");

  // DB 코드
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [fields, setFields] = useState([]);

  // 자동완성 선택값
  const [categoryLabel, setCategoryLabel] = useState("");
  const [categoryId, setCategoryId] = useState(null);

  const [itemLabel, setItemLabel] = useState("");
  const [itemId, setItemId] = useState(null);

  const [fieldLabel, setFieldLabel] = useState("");
  const [fieldId, setFieldId] = useState(null);

  // 드롭다운 ON/OFF
  const [showCategoryList, setShowCategoryList] = useState(false);
  const [showItemList, setShowItemList] = useState(false);
  const [showFieldList, setShowFieldList] = useState(false);

  // 각 입력란 강조 index
  const [catHighlightIdx, setCatHighlightIdx] = useState(-1);
  const [itemHighlightIdx, setItemHighlightIdx] = useState(-1);
  const [fieldHighlightIdx, setFieldHighlightIdx] = useState(-1);

  // ✅ 내용 추가 유무
  const [hasAdditional, setHasAdditional] = useState("없음");
  const [additionalCount, setAdditionalCount] = useState("");
  const [additionalUnit, setAdditionalUnit] = useState("종");

  // ✅ 거래처 (다중 입력)
  const [vendors, setVendors] = useState([]);
  const [loadingVendors, setLoadingVendors] = useState(false);
  const [partnerList, setPartnerList] = useState([
    { name: "", id: null, show: false, highlight: -1 }
  ]);

  // ✅ 패널 데이터
  const [itemList, setItemList] = useState([]);
  const [salaryList, setSalaryList] = useState([]);

  // 금액
  const [supplyAmount, setSupplyAmount] = useState("");
  const [vat, setVat] = useState("");
  const totalAmount = useMemo(() => {
    const s = Number(supplyAmount) || 0;
    const v = Number(vat) || 0;
    return s + v;
  }, [supplyAmount, vat]);

  
  // ⬇ 품목 + 인건비 자동 합산
  useEffect(() => {
    try {
      console.log("📌 자동 합산 실행 itemList, salaryList:", itemList, salaryList);

      let supply = 0;
      let salaryTotal = 0;
      let vatSum = 0;

      itemList.forEach(it => {
        supply += Number(it.supply || it.supply_amount || 0);
        vatSum += Number(it.vat || 0);
      });

      salaryList.forEach(s => {
        const gross = Number((s.totalSalary || "0").toString().replace(/,/g, ""));
        salaryTotal += gross;
      });

      console.log("📊 supply:", supply, "salaryTotal:", salaryTotal, "vatSum:", vatSum);

      setSupplyAmount(String(supply + salaryTotal));
      setVat(String(vatSum));
    } catch (err) {
      console.error("❌ 자동 합산 오류:", err);
    }
  }, [itemList, salaryList]);



  // ✅ 거래방법
  const [payMethodLabel, setPayMethodLabel] = useState("계좌이체");
  
  const PAY_METHOD_LABELS = ["계좌이체", "카드결제", "현금결제"];
  const PAY_METHOD_TO_CODE = { 
    "계좌이체": "transfer", 
    "카드결제": "card", 
    "현금결제": "cash" 
  };

  // ✅ 각 드롭다운의 ref 추가
  const categoryRef = useRef(null);
  const itemRef = useRef(null);
  const fieldRef = useRef(null);

  // DB LOAD
  useEffect(() => {
    (async () => {
      try {
        const resCat = await api.get("/expense/usage/category/");
        const resItem = await api.get("/expense/usage/item/");
        const resField = await api.get("/expense/usage/field/");
      
        setCategories(resCat.data);
        setItems(resItem.data);
        setFields(resField.data);

        setLoadingVendors(true);
        const resVendor = await api.get("vendors/");
        setVendors(Array.isArray(resVendor.data) ? resVendor.data : resVendor.data.results || []);
      } catch (err) {
        console.error("❌ 코드 불러오기 실패:", err);
      } finally {
        setLoadingVendors(false);
      }
    })();
  }, []);

  // ✅ 외부 클릭 감지
  useEffect(() => {
    function handleClickOutside(event) {
      if (categoryRef.current && !categoryRef.current.contains(event.target)) {
        setShowCategoryList(false);
      }
      if (itemRef.current && !itemRef.current.contains(event.target)) {
        setShowItemList(false);
      }
      if (fieldRef.current && !fieldRef.current.contains(event.target)) {
        setShowFieldList(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const yymmdd = useMemo(() => draftDate.replaceAll("-", "").slice(2), [draftDate]);
  const draftNo = useMemo(() => `금천일자리(주)카페금나래지출-${yymmdd}-${seq}호`, [yymmdd, seq]);

  // ✅ keep-alive 탭 재방문 시 다음 번호를 다시 조회(마운트가 유지돼 처음 조회값에 멈춰 있지 않게)
  const [seqRefreshTick, setSeqRefreshTick] = useState(0);
  useTabActivated(() => setSeqRefreshTick((t) => t + 1));
  useEffect(() => {
    let ignore = false;
    async function fetchSeq() {
      try {
        const { data } = await api.get(`/expense/cafe/geumnarae/next-seq/?date=${draftDate}`);
        if (!ignore) setSeq(String(data.next_seq).padStart(3, "0"));
      } catch (err) {
        console.error("❌ next-seq 오류:", err);
      }
    }
    fetchSeq();
    return () => { ignore = true; };
  }, [draftDate, seqRefreshTick]);

  // ✅ 제목 자동완성
  useEffect(() => {
    if (!executionDate || !categoryLabel || !itemLabel || !fieldLabel) return;
    const d = new Date(executionDate);
    const formatted = `${d.getFullYear()}년 ${String(d.getMonth()+1).padStart(2,"0")}월 ${String(d.getDate()).padStart(2,"0")}일`;
    
    let mid = `${categoryLabel}(${itemLabel}`;
    
    if (hasAdditional === "있음" && Number(additionalCount) > 0) {
      mid += ` 외 ${additionalCount}${additionalUnit}`;
    }
    
    mid += ")";
    setTitle(`${formatted} ${mid} ${fieldLabel}`);
  }, [executionDate, categoryLabel, itemLabel, hasAdditional, additionalCount, additionalUnit, fieldLabel]);

  async function onSubmit(e) {
    e.preventDefault();
    if (saving) return;

    // ✅ 유효성 검사
    if (!executionDate) {
      alert("집행예정일을 입력해주세요.");
      return;
    }
    
    if (!categoryId) {
      alert("사용내역 구분명을 선택하세요.");
      return;
    }
    
    if (!itemId) {
      alert("사용내역 내용명을 선택하세요.");
      return;
    }
    
    if (!fieldId) {
      alert("사용내역 분야명을 선택하세요.");
      return;
    }
    
    const validVendor = partnerList.some(v => v.name.trim() !== "");
    if (!validVendor) {
      alert("최소 1개 이상의 거래처가 필요합니다.");
      return;
    }
    
    if (!supplyAmount || Number(supplyAmount) === 0) {
      alert("공급가를 입력해주세요.");
      return;
    }

    setSaving(true);

    // ✅ 거래처 데이터 정제
    const cleanedPartners = partnerList
      .filter(p => p.name.trim() !== "")
      .map(p => ({
        name: p.name,
        id: p.id
      }));

    const payload = {
      draft_date: draftDate,
      execution_date: executionDate,
      
      // 대표 거래처(기존 호환성)
      partner_name: partnerList[0]?.name || "",
      partner_id: partnerList[0]?.id || null,
      
      // ✅ 다중 거래처
      partners: cleanedPartners,
      
      // ✅ 품목 패널
      items: itemList,
      
      // ✅ 인건비 패널
      salaries: salaryList,
      
      category_name: categoryLabel,
      item_name: itemLabel,
      field_name: fieldLabel,
      other_count: hasAdditional === "있음" ? Number(additionalCount) || 0 : 0,
      title,
      supply_amount: Number(supplyAmount) || 0,
      vat: Number(vat) || 0,
      pay_method: PAY_METHOD_TO_CODE[payMethodLabel] || "transfer",
      remark,
    };

    console.log("📤 전송 payload:", payload);

    try {
      const { data } = await api.post("expense/cafe/geumnarae/", payload);
      setSavedId(data.id);
      alert(`✅ 저장 완료!\n기안번호: ${data.draft_no}`);
      
      // ✅ 저장 후 다음 seq 자동 갱신
      const next = await api.get(`/expense/cafe/geumnarae/next-seq/?date=${draftDate}`);
      setSeq(String(next.data.next_seq).padStart(3, "0"));

      // ✅ 저장 후 입력값 초기화
      setExecutionDate("");
      setCategoryLabel("");
      setCategoryId(null);
      setItemLabel("");
      setItemId(null);
      setFieldLabel("");
      setFieldId(null);
      setPartnerList([{ name: "", id: null, show: false, highlight: -1 }]);
      setSupplyAmount("");
      setVat("");
      setRemark("");
      setTitle("");
      setItemList([]);
      setSalaryList([]);
      setHasAdditional("없음");
      setAdditionalCount("");
    } catch (err) {
      console.error("❌ 저장 실패:", err.response?.data || err);
      alert("서버 저장 실패: " + JSON.stringify(err.response?.data || err));
    } finally {
      setSaving(false);
    }
  }

  const filteredCategories = categories.filter((c) =>
    c.name.toLowerCase().includes(categoryLabel.toLowerCase())
  );
  
  const filteredItems = items.filter((i) =>
    i.name.toLowerCase().includes(itemLabel.toLowerCase())
  );
  
  const filteredFields = fields.filter((f) =>
    f.name.toLowerCase().includes(fieldLabel.toLowerCase())
  );
  
  // ✅ 구분명 키보드 핸들러
  const handleCategoryKeyDown = (e) => {
    if (!showCategoryList || !filteredCategories.length) return;
    
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setCatHighlightIdx((i) => (i < filteredCategories.length - 1 ? i + 1 : 0));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setCatHighlightIdx((i) => (i > 0 ? i - 1 : filteredCategories.length - 1));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (catHighlightIdx >= 0 && filteredCategories[catHighlightIdx]) {
        const c = filteredCategories[catHighlightIdx];
        setCategoryLabel(c.name);
        setCategoryId(c.id);
        setShowCategoryList(false);
      }
    } else if (e.key === "Escape") {
      setShowCategoryList(false);
    }
  };

  // ✅ 내용명 키보드 핸들러
  const handleItemKeyDown = (e) => {
    if (!showItemList || !filteredItems.length) return;
    
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setItemHighlightIdx((i) => (i < filteredItems.length - 1 ? i + 1 : 0));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setItemHighlightIdx((i) => (i > 0 ? i - 1 : filteredItems.length - 1));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (itemHighlightIdx >= 0 && filteredItems[itemHighlightIdx]) {
        const it = filteredItems[itemHighlightIdx];
        setItemLabel(it.name);
        setItemId(it.id);
        setShowItemList(false);
      }
    } else if (e.key === "Escape") {
      setShowItemList(false);
    }
  };

  // ✅ 분야명 키보드 핸들러
  const handleFieldKeyDown = (e) => {
    if (!showFieldList || !filteredFields.length) return;
    
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setFieldHighlightIdx((i) => (i < filteredFields.length - 1 ? i + 1 : 0));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setFieldHighlightIdx((i) => (i > 0 ? i - 1 : filteredFields.length - 1));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (fieldHighlightIdx >= 0 && filteredFields[fieldHighlightIdx]) {
        const f = filteredFields[fieldHighlightIdx];
        setFieldLabel(f.name);
        setFieldId(f.id);
        setShowFieldList(false);
      }
    } else if (e.key === "Escape") {
      setShowFieldList(false);
    }
  };

  return (
    <div className={styles.wrap}>
      {/* ✅ 왼쪽 + 오른쪽 패널을 묶는 flex row */}
      <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "0px" }}>
        
        {/* ✅ 왼쪽 기존 기안서 작성 */}
        <div style={{ flex: "0 0 10%" }}>
          <div className={styles.pane}>
            <form className={styles.form} onSubmit={onSubmit}>
              <h3>(구) 지출기안서 작성</h3>

              <Row label="기안번호(자동완성)">
                <input 
                  value={draftNo} 
                  readOnly 
                  className={styles.draftNoInput}
                />
              </Row>

              <Row label="제목(자동완성)">
                <input value={title} readOnly placeholder="자동 생성됩니다." />
              </Row>

              <Row label="사업구분">
                <input value="CAFE_INN 금나래점" readOnly />
              </Row>    

              <Row label="작성일">
                <input type="date" value={draftDate} onChange={(e) => setDraftDate(e.target.value)} />
              </Row>

              <Row label="집행예정일">
                <input type="date" value={executionDate} onChange={(e) => setExecutionDate(e.target.value)} />
              </Row>

              {/* ✅ 사용내역 구분명 */}
              <Row label="사용내역 구분명">
                <div className={styles.partnerRow} ref={categoryRef}>
                  <div style={{ position: 'relative' }}>
                    <input
                      placeholder="주재료, 소독용품, 용역용품 등"
                      value={categoryLabel}
                      onChange={(e) => {
                        setCategoryLabel(e.target.value);
                        setShowCategoryList(true);
                        setCatHighlightIdx(-1);
                      }}
                      onFocus={() => setShowCategoryList(true)}
                      onKeyDown={handleCategoryKeyDown}
                    />
                    <button
                      type="button"
                      className={styles.partnerButton}
                      onClick={() => setShowCategoryList((v) => !v)}
                    >
                      ▼
                    </button>
                  </div>
                  {showCategoryList && (
                    <div className={styles.partnerBox}>
                      {filteredCategories.length ? (
                        filteredCategories.map((c, i) => (
                          <div
                            key={c.id}
                            className={`${styles.partnerItem} ${i === catHighlightIdx ? styles.activeItem : ""}`}
                            onClick={() => {
                              setCategoryLabel(c.name);
                              setCategoryId(c.id);
                              setShowCategoryList(false);
                            }}
                          >
                            {c.name}
                          </div>
                        ))
                      ) : (
                        <div>일치하는 항목 없음</div>
                      )}
                    </div>
                  )}
                </div>
              </Row>

              {/* ✅ 사용내역 내용명 */}
              <Row label="사용내역 내용명">
                <div className={styles.partnerRow} ref={itemRef}>
                  <div style={{ position: 'relative' }}>
                    <input
                      placeholder="원두, 끈끈이, 빗자루 등"
                      value={itemLabel}
                      onChange={(e) => {
                        setItemLabel(e.target.value);
                        setShowItemList(true);
                        setItemHighlightIdx(-1);
                      }}
                      onFocus={() => setShowItemList(true)}
                      onKeyDown={handleItemKeyDown}
                    />
                    <button
                      type="button"
                      className={styles.partnerButton}
                      onClick={() => setShowItemList((v) => !v)}
                    >
                      ▼
                    </button>
                  </div>
                  {showItemList && (
                    <div className={styles.partnerBox}>
                      {filteredItems.length ? (
                        filteredItems.map((it, i) => (
                          <div
                            key={it.id}
                            className={`${styles.partnerItem} ${i === itemHighlightIdx ? styles.activeItem : ""}`}
                            onClick={() => {
                              setItemLabel(it.name);
                              setItemId(it.id);
                              setShowItemList(false);
                            }}
                          >
                            {it.name}
                          </div>
                        ))
                      ) : (
                        <div>일치하는 항목 없음</div>
                      )}
                    </div>
                  )}
                </div>
              </Row>

              {/* ✅ 내용 추가 유무 */}
              <Row label="내용 추가 유무">
                <div className={styles.inline}>
                  <label className={styles.check}>
                    <input
                      type="checkbox"
                      checked={hasAdditional === "없음"}
                      onChange={() => setHasAdditional("없음")}
                    />
                    없음
                  </label>
                  <label className={styles.check}>
                    <input
                      type="checkbox"
                      checked={hasAdditional === "있음"}
                      onChange={() => setHasAdditional("있음")}
                    />
                    있음
                  </label>
                  <input
                    type="number"
                    value={additionalCount}
                    onChange={(e) => setAdditionalCount(e.target.value)}
                    placeholder="숫자"
                    disabled={hasAdditional === "없음"}
                    style={{ 
                      width: "60px",
                      margin: "0 6px",
                      height: "24px",
                      padding: "0 6px",
                      border: "1px solid #d1d5db",
                      borderRadius: "4px",
                      flexShrink: 0
                    }}
                  />
                  <label className={styles.check}>
                    <input
                      type="checkbox"
                      checked={additionalUnit === "종"}
                      onChange={() => setAdditionalUnit("종")}
                      disabled={hasAdditional === "없음"}
                    />
                    종
                  </label>
                  <label className={styles.check}>
                    <input
                      type="checkbox"
                      checked={additionalUnit === "명"}
                      onChange={() => setAdditionalUnit("명")}
                      disabled={hasAdditional === "없음"}
                    />
                    명
                  </label>
                </div>
              </Row>

              {/* ✅ 사용내역 분야명 */}
              <Row label="사용내역 분야명">
                <div className={styles.partnerRow} ref={fieldRef}>
                  <div style={{ position: 'relative' }}>
                    <input
                      placeholder="구입, 결제, 지급 등"
                      value={fieldLabel}
                      onChange={(e) => {
                        setFieldLabel(e.target.value);
                        setShowFieldList(true);
                        setFieldHighlightIdx(-1);
                      }}
                      onFocus={() => setShowFieldList(true)}
                      onKeyDown={handleFieldKeyDown}
                    />
                    <button
                      type="button"
                      className={styles.partnerButton}
                      onClick={() => setShowFieldList((v) => !v)}
                    >
                      ▼
                    </button>
                  </div>
                  {showFieldList && (
                    <div className={styles.partnerBox}>
                      {filteredFields.length ? (
                        filteredFields.map((f, i) => (
                          <div
                            key={f.id}
                            className={`${styles.partnerItem} ${i === fieldHighlightIdx ? styles.activeItem : ""}`}
                            onClick={() => {
                              setFieldLabel(f.name);
                              setFieldId(f.id);
                              setShowFieldList(false);
                            }}
                          >
                            {f.name}
                          </div>
                        ))
                      ) : (
                        <div>일치하는 항목 없음</div>
                      )}
                    </div>
                  )}
                </div>
              </Row>

              <Row label="금액(자동완성)">
                <div className={styles.amountBox}>
                  <input
                    value={supplyAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    onChange={(e) => {
                      const raw = e.target.value.replace(/,/g, "");
                      if (!isNaN(raw)) setSupplyAmount(raw);
                    }}
                    placeholder="공급가"
                  />
                  +
                  <input
                    value={vat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    onChange={(e) => {
                      const raw = e.target.value.replace(/,/g, "");
                      if (!isNaN(raw)) setVat(raw);
                    }}
                    placeholder="부가세"
                  />
                  =
                  <input readOnly value={totalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} placeholder="합계" />
                </div>
              </Row>

              {/* ✅ 거래방법 */}
              <Row label="거래방법">
                <div className={styles.inline}>
                  {PAY_METHOD_LABELS.map((label) => (
                    <label key={label} className={styles.check}>
                      <input
                        type="checkbox"
                        checked={payMethodLabel === label}
                        onChange={() => setPayMethodLabel(label)}
                      />
                      {label}
                    </label>
                  ))}
                </div>
              </Row>

              <Row label="비고">
                <textarea
                  rows={1}
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="지출 메모 입력"
                />
              </Row>

              <div className={styles.actions}>
                <button type="submit" disabled={saving}>
                  {saving ? "저장 중..." : "저장"}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* ✅ 오른쪽 패널 추가 */}
        <div style={{ flex: "1", padding: "0px" }}>
          <VendorPanel
            vendors={vendors}
            loadingVendors={loadingVendors}
            onChange={(list) => setPartnerList(list)}
          />
          <ExpenseItemPanel onItemsChange={setItemList} />
          <SalaryPanel onItemsChange={setSalaryList} />
        </div>
      </div>
    </div>
  );
}

function Row({ label, children }) {
  return (
    <div className={styles.row}>
      <div className={styles.rowLabel}>{label}</div>
      <div className={styles.rowField}>{children}</div>
    </div>
  );
}

function toISO(d) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}